function getUserAgent(name) {
  return navigator.userAgent.toLowerCase().match(new RegExp(name.toLowerCase(), 'i'));
}

export default function launchApplicationMarket(id) {
  if (getUserAgent('iPhone') || getUserAgent('iPod') || getUserAgent('iPad')) {
    window.location.href = `https://itunes.apple.com/cn/app/id${id}`;
    return;
  }
  if (getUserAgent('vivo')) {
    window.location.href = `vivomarket://details?id=${id}`;
    return;
  }
  if (getUserAgent('oppo')) {
    window.location.href = `oppomarket://details?packagename=${id}`;
    return;
  }
  if (getUserAgent('HUAWEI') || getUserAgent('HONOR')) {
    window.location.href = `appmarket://details?id=${id}`;
    return;
  }
  if (getUserAgent('mi')) {
    window.location.href = `mimarket://details?id=${id}`;
    return;
  }
  if (getUserAgent('samsung')) {
    window.location.href = `samsungapps://ProductDetail/${id}`;
    return;
  }
  window.location.href = `https://sj.qq.com/appdetail/${id}`;
}
